import { DateTime } from 'luxon';
import * as yup from 'yup';

type CarrierRestrictionsFormState = {
  carrierId: number | null;
  carrierName: string;
  carrierMc: string;
  carrierDot: string;
  restrictionType: 'Hard Block' | 'Warning';
  effectiveFrom: string;
  effectiveTo: string;
  reasonType: string;
  reasonDescription: string;
};

const carrierRestrictionFormSchema = yup.object().shape({
  carrierId: yup.number().nullable().required('Carrier is required'),
  carrierName: yup.string().required('Carrier is required'),
  carrierMc: yup.string().required('MC is required'),
  carrierDot: yup.string().required('DOT is required'),
  restrictionType: yup
    .mixed<CarrierRestrictionsFormState['restrictionType']>()
    .oneOf(['Hard Block', 'Warning'], 'Invalid restriction type')
    .required('Restriction type is required'),
  effectiveFrom: yup
    .string()
    .required('Effective From is required')
    .test('is-valid-date', 'Invalid date', (value) => {
      if (!value) return true;
      return DateTime.fromISO(value).isValid;
    }),
  effectiveTo: yup
    .string()
    .nullable()
    .test('is-valid-date', 'Invalid date', (value) => {
      if (!value) return true;
      return DateTime.fromISO(value).isValid;
    })
    .test(
      'is-after-effective-from',
      'Effective To must be after Effective From',
      function (value) {
        const effectiveFrom = (this.parent as CarrierRestrictionsFormState)
          .effectiveFrom as unknown as string | undefined;
        if (!value || !effectiveFrom) return true;
        return DateTime.fromISO(value) > DateTime.fromISO(effectiveFrom);
      },
    ),
  reasonType: yup.string().required('Reason type is required'),
  reasonDescription: yup
    .string()
    .required('Reason description is required')
    .max(5000, 'Description must be at most 5000 characters'),
});

export { carrierRestrictionFormSchema, type CarrierRestrictionsFormState };
